<template>
  <div>
    <z-centralized-toolbar>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mr-2"
            v-on="on"
            depressed
            rounded
            color="primary"
            :dark="caixaAtual"
            :disabled="!caixaAtual"
            @click="novoLancamento"
          >
            <v-icon left>add</v-icon>
            Lançar no Caixa
          </v-btn>
        </template>
        Lançar no Caixa
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            depressed
            v-on="on"
            :color="exibir_saldo ? 'primary' : ''"
            :text="!exibir_saldo"
            @click="exibir_saldo = !exibir_saldo"
          >
            Saldo
          </v-btn>
        </template>
        Exibir Saldo
      </v-tooltip>

      <z-menu-impressoes :itens="impressoes" @abrir:relatorio="abrirRelatorio"></z-menu-impressoes>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :loading="$store.state.loading"
            @click="refresh"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        Atualizar
      </v-tooltip>

      <!-- <v-spacer></v-spacer> -->

      <z-date-navigation
        v-model="data"
        class="ml-5"
        @input="refresh"
      ></z-date-navigation>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Caixa</h3>

      <v-row dense>
        <v-slide-x-transition hide-on-leave>
          <v-col sm="3" v-show="exibir_saldo">
            <v-card>
              <v-toolbar dense flat color="white" class="text-body-1">
                Saldo do Caixa
                <v-spacer></v-spacer>
                <v-btn small icon @click="exibir_saldo = false">
                  <v-icon >mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  small
                  depressed
                  block
                  color="red"
                  :disabled="!caixaAtual"
                  :dark="caixaAtual"
                  @click="novaSangria"
                >
                  Efetuar Sangria
                </v-btn>
              </v-card-actions>

              <v-divider></v-divider>

              <v-data-table
                hide-default-footer
                disable-pagination
                :headers="headers_resumo"
                :items="resumo_nao_zerado"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.forma_pagamento }}</td>
                    <td class="text-right font-weight-bold">{{ props.item.total | valorBR }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td>
                      <strong>Total</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ resumo_nao_zerado.reduce((soma, linha) => soma + linha.total,0) | valorBR }}</strong>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-slide-x-transition>

        <v-col :sm="exibir_saldo ? 9 : 12">
          <v-card>

            <v-data-table
              hide-default-footer
              item-key="id"
              disable-pagination
              :headers="headers"
              :items="caixa"
              :loading="false"
              :search="search"
            >
              <template v-slot:item="props">
                <tr>
                  <td>{{ props.item.data | dataBR }}</td>
                  <td>{{ props.item.descricao }}</td>
                  <td>{{ props.item.forma_pagamento }}</td>
                  <td class="text-center">
                    <v-chip dark small :color="props.item.tipo == 'Entrada' ? 'green' : 'red'">{{ props.item.tipo }}</v-chip>
                  </td>
                  <td class="text-right">{{ props.item.valor | valorBR }}</td>
                  <td class="text-center">
                    <v-tooltip bottom :hidden="!caixaAtual">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          class="ma-0"
                          @click="perguntarExcluir(props.item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir Lançamento</span>
                    </v-tooltip>
                    <!-- <v-menu offset-y>
                          <v-btn icon slot="activator">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-item @click="editar(props.item)">
                              <v-list-item-action>
                                <v-icon>edit</v-icon>
                              </v-list-item-action>
                              <v-list-item-title>Editar Lançamento</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="red--text" @click="perguntarExcluir(props.item)">
                              <v-list-item-action>
                                <v-icon color="red">delete</v-icon>
                              </v-list-item-action>
                              <v-list-item-title>Excluir Lançamento</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </z-container>

    <z-dialogo
      ref="dialogoExcluir"
      titulo="Deseja excluir esse lançamento do caixa?"
      :dividers="true"
      largura="500px"
    >
      <div slot="texto">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Data</v-list-item-subtitle>
              <v-list-item-title>{{ lancamento.data | dataBR }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Descrição</v-list-item-subtitle>
              <v-list-item-title>{{ lancamento.descricao }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Forma de Pagamento</v-list-item-subtitle>
              <v-list-item-title>{{ lancamento.forma_pagamento }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Tipo</v-list-item-subtitle>
              <v-list-item-title :class="lancamento.tipo == 'Entrada' ? 'green--text' : 'red--text'" >{{ lancamento.tipo }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Valor</v-list-item-subtitle>
              <v-list-item-title>{{ lancamento.valor | valorBR }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo">Cancelar</v-btn>
      <v-btn
        color="primary darken-1"
        text
        :loading="excluindo"
        :disabled="excluindo"
        @click="confirmarExcluir"
        >Excluir</v-btn>
    </z-dialogo>

    <z-dialogo
      ref="dialogoLancamento"
      titulo="Lançamento no Caixa"
      largura="750px"
      eager
      :dividers="true"
    >
      <template v-slot:texto>
        <v-form ref="form" v-model="form_valido" lazy-validation>
          <v-row dense> 
            <v-col sm="3">
              <z-date-picker-menu
                v-model="lancamento.data"
                placeholder=" "
                label="Data"
                readonly
                filled
                dense
              ></z-date-picker-menu>
            </v-col>
            <v-col sm="9">
              <v-text-field
                v-model="lancamento.descricao"
                ref="descricao"
                placeholder=" "
                label="Descrição"
                autofocus
                filled
                dense
                :rules="regras.descricao"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col sm="4">
              <z-campo-valor
                v-model="lancamento.valor"
                placeholder=" "
                label="Valor"
                ref="valor"
                filled
                dense
                :rules="regras.valor"
              ></z-campo-valor>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="lancamento.forma_pagamento"
                label="Forma de Pagamento"
                filled
                dense
                :rules="regras.forma_pagamento"
                :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA"
              ></v-select>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="lancamento.tipo"
                label="Tipo"
                filled
                dense
                :items="$globals.TIPO_LANCAMENTO"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </template>

      <v-btn text @click="$refs.dialogoLancamento.fechar()" :disabled="salvando">Cancelar</v-btn>
      <v-btn
        color="primary"
        depressed
        :loading="salvando"
        :disabled="salvando || !form_valido"
        @click="confirmarLancamento"
        >Lançar</v-btn>
    </z-dialogo>

    <z-dialogo
      ref="dialogoSangria"
      titulo="Sangria"
      largura="750px"
      eager
      :dividers="true"
    >
      <div slot="texto">
        <v-form
          v-model="form_valido_sangria"
          ref="form_sangria"
          lazy-validation
        >
          <v-row dense>
            <v-col sm="4">
              <z-date-picker-menu
                v-model="lancamento.data"
                placeholder=" "
                label="Data"
                readonly
                filled
                dense
              ></z-date-picker-menu>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="lancamento.forma_pagamento"
                label="Forma de Pagamento"
                :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col sm="4">
              <z-campo-valor
                ref="valor_sangria"
                v-model="lancamento.valor"
                placeholder=" "
                label="Valor"
                :rules="regras.valor"
                filled
                dense
              ></z-campo-valor>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <v-btn text @click="$refs.dialogoSangria.fechar()" :disabled="salvando">Cancelar</v-btn>
      <v-btn
        color="primary darken-1"
        depressed
        :loading="salvando"
        :disabled="salvando || !form_valido_sangria"
        @click="confirmarSangria"
        >Lançar</v-btn>
    </z-dialogo>


    <caixa-diario ref="dialogoCaixaDiario" :data="data" @imprimir="imprimirCaixaDiario"></caixa-diario>
    <meses-anos ref="dialogoMesesAnos" @imprimir="imprimirCaixaMensal"></meses-anos>
    <z-dialogo-intervalo-data ref="dialogoIntervaloData" titulo="Relatório Caixa por Período" @imprimir="imprimirCaixaPeriodo"></z-dialogo-intervalo-data>

    <z-dialogo-sim-nao
      ref="dialogoImpressaoTerminca"
      titulo="Imprimir na impressora térmica?"
      botaoSim="Impressora Térmica"
      botaoNao="Impressora Padrão"
      largura="500px"
    >
      A impressora térmica está habilitada no sistema. Deseja imprimir na impressora térmica?
    </z-dialogo-sim-nao>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { mapStores } from 'pinia'
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import { parseParams } from '@/app/helpers/utils';
import caixaApi from '@/app/services/caixa';

import MesesAnos from './MesesAnos';
import CaixaDiario from './CaixaDiario';

export default {
  name: 'CaixaLista',

  components: {
    MesesAnos,
    CaixaDiario,
  },

  inject: ["$imprimir"],

  created() {
    this.setTitulo("Movimento de Caixa");
    this.refresh();
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Data", value: "data", width: "120px" },
        { text: "Decrição", value: "descricao" },
        { text: "Forma de Pagamento", value: "forma_pagamento" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "Valor", value: "valor", align: "right" },
        { text: "Opções", value: "", align: "center", sortable: false },
      ],
      headers_resumo: [
        {
          text: "Forma Pagamento",
          value: "forma_pagamento",
          width: "150px",
          sortable: false,
        },
        { text: "Valor", value: "valor", align: "right", sortable: false },
      ],
      impressoes: [
        { texto: 'Caixa do Dia', acao: 'caixa_diario', visible: true },
        { texto: 'Caixa Mensal', acao: 'caixa_mensal', visible: true },
        { texto: 'Caixa Período', acao: 'caixa_periodo', visible: true },
        { texto: 'Relatório Gerencial', acao: 'relatorio_gerencial', visible: this.$auth.isAdmin()}
      ],
      search: "",
      pagination: {},
      excluindo: false,
      salvando: false,
      lancamento: {
        data: "",
        descricao: "",
        tipo: "",
        forma_pagamento: "",
        valor: "",
      },
      regras: {
        descricao: [(v) => !!v || "O campo descrição é obrigatório"],
        valor: [(v) => v != "0,00" || "O campo valor não pode ser zero"],
        forma_pagamento: [
          (v) => !!v || "O campo forma de pagamento é obrigatório",
        ],
      },
      form_valido: false,
      form_valido_sangria: false,
      data: this.$moment().format("YYYY-MM-DD"),
      exibir_saldo: false,
    };
  },


  computed: {
    ...mapState("caixa", ["caixa", "resumo"]),
    ...mapGetters("caixa", ["resumo_nao_zerado"]),
    ...mapStores(useConfigStore),

    caixaAtual() {
      return this.data == this.hoje();
    },

    configuracoes() {
      return this.configStore.configuracoes;
    },
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("caixa", [
      "listar",
      "excluir",
      "abrir",
      "salvar",
      "salvarSangria",
      "atualizar",
    ]),

    async refresh() {
      try {
        console.log(this.data);
        await this.listar(this.data);
      } catch (error) {
        this.$eventbus.erro("Não foi possível obter a lista do caixa.", error);
        this.LOADING_OFF();
      }
    },

    async editar(caixa) {
      await this.abrir(caixa.id);
      this.$router.push({ name: "CaixaEditar", params: { id: caixa.id } });
    },

    novoLancamento() {
      this.$refs.form.resetValidation();
      this.lancamento = {
        data: this.$moment().format("YYYY-MM-DD"),
        descricao: "",
        tipo: "Entrada",
        forma_pagamento: "Dinheiro",
        valor: 0,
      };
      this.setFocus("descricao");
      this.$refs.dialogoLancamento.abrir();
    },

    novaSangria() {
      this.$refs.form_sangria.resetValidation();
      this.lancamento = {
        data: this.$moment().format("YYYY-MM-DD"),
        descricao: "Sangria do Caixa",
        tipo: "Sangria",
        forma_pagamento: "Dinheiro",
        valor: 0,
      };
      this.setFocus("valor_sangria");
      this.$refs.dialogoSangria.abrir();
    },

    async confirmarLancamento() {
      if (this.$refs.form.validate()) {
        this.salvando = true;
        try {
          await this.salvar(this.lancamento);
          this.$refs.dialogoLancamento.fechar();
        } catch (error) {
          this.$eventbus.erro("Não foi possível salvar o lançamento.", error);
          this.LOADING_OFF();
        } finally {
          this.salvando = false;
        }
      }
    },

    async confirmarSangria() {
      if (this.$refs.form_sangria.validate()) {
        this.salvando = true;
        try {
          await this.salvarSangria(this.lancamento);
          this.$refs.dialogoSangria.fechar();
        } catch (error) {
          this.$eventbus.erro("Não foi possível salvar a sangria.", error);
          this.LOADING_OFF();
        } finally {
          this.salvando = false;
        }
      }
    },

    perguntarExcluir(lancamento) {
      this.lancamento = lancamento;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.lancamento);
        this.$eventbus.notificar("Lançamento de caixa excluído com sucesso!");
      } catch (error) {
        this.$eventbus.erro("Não foi possível excluir esse lançamento.", error);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
      }
    },

    // imprimirCaixaDiario_(filtro) {
    //   console.log("APP_IMPRESSAO_TERMICA", this.configuracoes.APP_IMPRESSAO_TERMICA);

    //   this.$imprimir(`relatorios/caixa/imprimir?data=${this.data}&` + new URLSearchParams(filtro).toString());
    // },

    async imprimirCaixaDiario(filtro) {
      let impressao_termica = false;
      
      if (filtro.impressao === 'meucaixa') {
        impressao_termica = await this.imprimirNaImpressoraTermica();
      }

      if (impressao_termica) {
        filtro.vendedor_id = this.$auth.user.id;
        caixaApi.impressaoTermica({ data: this.data, filtro: parseParams(filtro) }).then((response) => {
          this.$eventbus.notificar("Impressão enviada para a fila.");
        }).catch((error) => {
          this.$eventbus.erro("Não foi possível enviar a impressão para a fila.", error);
        });
      } else {
        // this.$imprimir(`relatorios/caixa/imprimir?data=${this.data}&` + new URLSearchParams(filtro).toString(), "Caixa_" + this.data + ".pdf");
        this.$imprimir(`relatorios/caixa/imprimir?data=${this.data}&` + new URLSearchParams(parseParams(filtro)).toString(), "Caixa_" + this.data + ".pdf");
      }
    },

    async imprimirNaImpressoraTermica() {
      let response = false;
      if (this.configuracoes.APP_IMPRESSAO_TERMICA) {
        response = await this.$refs.dialogoImpressaoTerminca.abrir();
      }

      this.$refs.dialogoImpressaoTerminca.fechar();
      return this.configuracoes.APP_IMPRESSAO_TERMICA && response === true;
    },

    imprimirCaixaGerencial() {
      this.$imprimir(`relatorios/caixa/imprimir/gerencial?data=${this.data}`);
    },

    imprimirCaixaMensal({ mes, ano }) {
      this.$refs.dialogoMesesAnos.fechar();

      setTimeout(() => {
        this.$imprimir(`relatorios/caixa/imprimir/mensal?mes=${mes}&ano=${ano}`);
      }, 300);
    },

    imprimirCaixaPeriodo({ data_inicial, data_final }) {
      this.$refs.dialogoIntervaloData.fechar();

      setTimeout(() => {
        this.$imprimir(`relatorios/caixa/imprimir/periodo?data_inicial=${data_inicial}&data_final=${data_final}`);
      }, 300);
    },

    abrirRelatorio(relatorio) {

      console.log(relatorio);

      if (relatorio === 'caixa_diario') {
        // this.imprimirCaixaDiario();
        this.$refs.dialogoCaixaDiario.abrir();
      }

      if (relatorio === 'caixa_mensal') {
        this.$refs.dialogoMesesAnos.abrir();
      }

      if (relatorio === 'relatorio_gerencial') {
        this.imprimirCaixaGerencial();
      }

      if (relatorio === 'caixa_periodo') {
        this.$refs.dialogoIntervaloData.abrir();
      }
    },

    corChip(situacao) {
      switch (situacao) {
        case "Em Caixa":
          return "green";
          break;

        case "Compensado":
          return "blue";
          break;

        case "Devolvido":
          return "red";
          break;

        case "Repassado":
          return "orange";
          break;

        default:
          break;
      }
    },
  },

};
</script>

<style scoped></style>
